import React, { useContext, useState, useEffect } from 'react';
import { AppContext } from 'Context';
import { NavLink } from 'react-router-dom';
import cn from 'classnames';
import PersonAddAltIcon from '@mui/icons-material/PersonAddAlt';
import { Page } from 'Components';
import { Pathname } from 'Routes';
import styles from './PageClassic.module.css';

export const ViewerPage = ({ children, title, addActionName, link, subTitle, restricted, searchElement }) => {
  const { langText, setTopOrBottom } = useContext(AppContext);
  useEffect(() => {
    setTopOrBottom(true);
    return () => {
      setTopOrBottom(false); // Set topOrBottom to false when leaving the component
    };
  }, []);
  const sideBarText = langText?.viewersSideBar;
  const [isMouseOver, setMouseOver] = useState(false);
  const sidebarLinks = [
    { name: (sideBarText?.viewersSidebarTitle || 'Viewers'), link: Pathname.getViewersPath(Pathname.viewers.viewer) },
    { name: (sideBarText?.groupSidebarTitle || 'Groups'), link: Pathname.getViewersPath(Pathname.viewers.groups) },
    { name: (sideBarText?.successorSidebarTitle || 'Successors'), link: Pathname.getViewersPath(Pathname.viewers.successors) },
    { name: 'Connected Accounts', link: Pathname.getViewersPath(Pathname.viewers.connectedAccounts) },
  ];
  return (
    <Page contentClassName={restricted ? styles.pageContentRes : styles.pageContent} headerTheme={styles.headerTheme}>
      <div className={styles.settingsPage}>
        <div className={styles.sidebar}>
          <div className={styles.sidebarContent}>
            {sidebarLinks.map(({ name, link: sidebarLink }, idx) => {
              const isActive = window.location.pathname === sidebarLink;
              const navLinkClassName = cn(styles.sidebarLink, { [styles.currentSidebarLink]: isActive });
              return (
                <NavLink
                  key={idx}
                  to={sidebarLink}
                  className={navLinkClassName}
                >
                  {name}
                </NavLink>
              );
            })}
          </div>
        </div>
        <div className={styles.contentWrapper}>
          <div className={styles.headingWrapper}>
            <div className={styles.titleWithSearch}>
              <span
                className={styles.titleWrapper}
                style={
                  title === 'Viewers'
                    ? { display: 'flex', flexDirection: 'column' }
                    : {}
                }
              >
                <span
                  className={cn({
                    [styles.pageTitle]: true,
                    [styles.restrictedPageTitle]: restricted,
                  })}
                >
                  {subTitle ? `${title}: ` : title}
                </span>
                <span className={styles.subTitle}>{subTitle}</span>
              </span>
              {searchElement && <div className={styles.searchElementWrapper}>{searchElement}</div>}
            </div>

            {link && (
            <NavLink to={link}>
              <span className={styles.addNew}>
                <PersonAddAltIcon onMouseEnter={() => { setMouseOver(true); }} onMouseLeave={() => { setMouseOver(false); }} className={cn({ [styles.addIconStyle]: true, [styles.disabledbutton]: restricted, [styles.mouseOverClass]: isMouseOver })} />
              </span>
            </NavLink>
            )}
          </div>
          <div className={styles.content}>{children}</div>
        </div>
      </div>
    </Page>
  );
};
